import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  IconButton,
  Divider,
  Stack,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { COMPANY_INFO } from '../../utils/constants';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'grey.900',
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          sx={{ width: '100%' }}
        >
          <Box sx={{ flex: { xs: '1', md: '1' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              EZTECH
              <Box component="span" sx={{ color: 'primary.light', ml: 0.5 }}>
                SOLUTIONS
              </Box>
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'grey.400' }}>
              Solutions informatiques innovantes pour transformer votre entreprise
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                href="mailto:contact@eztech-solutions.fr"
                sx={{ color: 'grey.400', '&:hover': { color: 'primary.light' } }}
              >
                <EmailIcon />
              </IconButton>
            </Stack>
          </Box>

          <Box sx={{ flex: { xs: '1', md: '0.5' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Navigation
            </Typography>
            <Stack spacing={1}>
              <Link href="/" color="grey.400" underline="hover">
                Accueil
              </Link>
              <Link href="/#services" color="grey.400" underline="hover">
                Services
              </Link>
              <Link href="/#expertise" color="grey.400" underline="hover">
                Expertise
              </Link>
              <Link href="/#about" color="grey.400" underline="hover">
                À propos
              </Link>
              <Link href="/#contact" color="grey.400" underline="hover">
                Contact
              </Link>
            </Stack>
          </Box>

          <Box sx={{ flex: { xs: '1', md: '0.75' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Services
            </Typography>
            <Stack spacing={1}>
              <Link href="/#services" color="grey.400" underline="hover">
                Conseil Informatique
              </Link>
              <Link href="/#services" color="grey.400" underline="hover">
                Développement Logiciel
              </Link>
              <Link href="/#services" color="grey.400" underline="hover">
                Business Intelligence
              </Link>
              <Link href="/#services" color="grey.400" underline="hover">
                Data Science
              </Link>
              <Link href="/#services" color="grey.400" underline="hover">
                Cybersécurité
              </Link>
            </Stack>
          </Box>

          <Box sx={{ flex: { xs: '1', md: '0.75' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact
            </Typography>
            <Stack spacing={1.5}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <LocationOnIcon sx={{ fontSize: 20, mr: 1, color: 'grey.400', mt: 0.3 }} />
                <Typography variant="body2" color="grey.400">
                  {COMPANY_INFO.address.street}<br />
                  {COMPANY_INFO.address.postalCode} {COMPANY_INFO.address.city}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <EmailIcon sx={{ fontSize: 20, mr: 1, color: 'grey.400' }} />
                <Link href="mailto:contact@eztech-solutions.fr" color="grey.400" underline="hover">
                  contact@eztech-solutions.fr
                </Link>
              </Box>
            </Stack>
          </Box>
        </Stack>

        <Divider sx={{ my: 3, borderColor: 'grey.800' }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="body2" color="grey.400">
            © {currentYear} EZTECH SOLUTIONS - Tous droits réservés
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link href="/mentions-legales" color="grey.400" underline="hover">
              Mentions légales
            </Link>
            <Link href="/politique-confidentialite" color="grey.400" underline="hover">
              Politique de confidentialité
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;